import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  TableFooter,
  TablePagination,
  Button,
  Box,
} from '@mui/material';
import React from 'react';
import {useGetCitiesQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import CitiesDeleteIconButton from './CitiesDeleteIconButton';
import CitiesCreateModal from './CitiesCreateModal';
import CitiesEditIconButton from './CitiesEditIconButton';
import {getImageURL} from '../../../utils/imageUrl';

const totalColumns = 5;

function CitiesTable() {
  const {data, isLoading, isError, isSuccess} = useGetCitiesQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CitiesCreateModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="Cities Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>Cities</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Province</TableCell>
              <TableCell align="center">Country</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="right">{row.province.name}</TableCell>
                  <TableCell align="center">
                    <Box
                      component="img"
                      sx={{width: 40, height: 40, objectFit: 'contain'}}
                      src={getImageURL(row.country.flag)}
                      alt={row.name}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <CitiesEditIconButton city={row} />
                    <CitiesDeleteIconButton cityId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No city found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch cities.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={100}
                page={0}
                onPageChange={() => {
                  // console.log('onPageChange', rest);
                }}
                rowsPerPage={10}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  );
}

export default CitiesTable;
